import { Component, Input, OnInit } from '@angular/core';
// Services
import { RulesChangeService } from '../../services/rules-change.service';
// Models
import { RuleItemDirectiveDataModel } from '../../models/rule-item-directive.model';
import { RULE_WORKFLOW_SECTION } from '../../models/inline-rules.model';
import { RULE_MESSAGE_TYPE, RULE_STATUS } from '../../../../../../../rule-engine/rules/models';
import { RoomRulesDesign } from '../../../../models/components.options';
import { RulesEvents } from '../../models/inline-rules.event';

@Component({
	selector: 'cv-schema-render-rule-item',
	templateUrl: './rule-item.component.html',
	styleUrls: ['./rule-item.component.scss']
})
export class RuleItemComponent implements OnInit {
	@Input() ruleViolation;
	@Input() ruleWorkFlow;
	@Input() activeActions;
	@Input() collapsibleName;
	@Input() path;
	@Input() selectedItem;
	@Input() version;

	public ruleWorkflowSection = RULE_WORKFLOW_SECTION;
	public ruleStatus = RULE_STATUS;
	public ruleMessageType = RULE_MESSAGE_TYPE;
	public roomRulesVersionDesign = RoomRulesDesign
	ruleWorkflowSectionDetail;
	directiveData = new RuleItemDirectiveDataModel();

	get ruleItem(): any {
		return this.rulesChangeService.rulesItems[this.collapsibleName] || null;
	}

	constructor(
		private rulesChangeService: RulesChangeService
	) {
		//
	}

	ngOnInit(): void {
		this.directiveData.id = this.collapsibleName;
		this.directiveData.isCollapsed = this.selectedItem === this.collapsibleName;
		this.directiveData.path = this.path;
	}

	/**
	 * Doc must exist
	 * @param ruleWorkflowSection 
	 * @param ruleViolation 
	 */
	changeRuleFlow(ruleWorkflowSection, ruleViolation = null): void {
		this.ruleItem.isCollapsed = !this.ruleItem.isCollapsed;
		this.ruleWorkflowSectionDetail = ruleWorkflowSection;
		this.closeItems();
		this.rulesChangeService.rulesDataChanged.next(
			{
				type: RulesEvents.CHANGE_RULE_FLOW,
				ruleWorkflowSection,
				ruleViolation,
				path: this.path
			});
	}

	/**
	 * Doc must exist
	 */
	closeItems(): void {
		Object.keys(this.rulesChangeService.rulesItems).forEach(key => {
			const item = this.rulesChangeService.rulesItems[key];
			if (item.path == this.path) {
				if (key != this.ruleItem.id) {
					this.rulesChangeService.rulesItems[item.id].isCollapsed = false;
				}
			}
		});
	}

	/**
	 * Compares two section values, basically this was made to avoid a TS compilation error.
	 * @param value: RULE_WORKFLOW_SECTION
	 * @param target: RULE_WORKFLOW_SECTION
	 */
	public compareWorkflowSections(value: RULE_WORKFLOW_SECTION, target: RULE_WORKFLOW_SECTION): boolean {
		return value === target;
	}

	/**
	 * Doc must exist
	 * @param ruleViolation 
	 * @param ruleStatus 
	 */
	onUpdateStatus(ruleViolation, ruleStatus): void {
		this.rulesChangeService.rulesDataChanged.next({
			type: RulesEvents.UPDATE_STATUS,
			ruleViolation,
			ruleStatus,
			path: this.path
		});
	}

}
